<div id="meritorious-students" class="meritorious-page py-5">
  <div class="container-fluid px-lg-5">
    
    <!-- Title Header -->
    <div class="row mb-4">
      <div class="col-12 text-center">
        <h2 class="title fw-bold text-uppercase mb-2 text-green">
          <i class="fa-solid fa-award text-light-green me-2"></i> Meritorious Students List
        </h2>
        <p class="subtitle text-muted fs-6 mb-1">
          Shah Satnam Ji Girls' College, Sirsa — Annual Merit Lists
        </p>
        <div class="mt-2">
          <span class="badge bg-light text-dark border px-3 py-1.5 rounded-pill shadow-sm" style="font-size: 12px;">
            <i class="fa-solid fa-file-excel text-success me-1"></i> Data Source: <strong>{{ excelFilePath }}</strong> (View-Only Web Display)
          </span>
        </div>
      </div>
    </div>

    <!-- Session Navigation Tabs -->
    <div class="row mb-4">
      <div class="col-12">
        <div class="d-flex flex-wrap justify-content-center gap-2 session-tabs-container">
          <button 
            *ngFor="let s of sessions" 
            class="btn session-tab-btn px-4 py-2 rounded-pill fw-semibold transition-all"
            [class.btn-primary]="activeSessionName === s.session"
            [class.btn-outline-primary]="activeSessionName !== s.session"
            (click)="setSession(s.session)">
            <i class="fa-solid fa-calendar-days me-1"></i> {{ s.session }}
            <span class="badge bg-light text-dark ms-2 opacity-75">{{ getTotalStudentsCount(s) }}</span>
          </button>
        </div>
      </div>
    </div>

    <!-- Search & Filter Bar -->
    <div class="row justify-content-center mb-4">
      <div class="col-12 col-md-8 col-lg-6">
        <div class="input-group shadow-sm rounded-pill overflow-hidden border">
          <span class="input-group-text bg-white border-0 ps-4">
            <i class="fa-solid fa-magnifying-glass text-muted"></i>
          </span>
          <input 
            type="text" 
            class="form-control border-0 py-2.5 px-2 shadow-none" 
            placeholder="Search by Student Name, Roll No., Father Name or Course..."
            [(ngModel)]="searchTerm">
          <button 
            *ngIf="searchTerm" 
            class="btn btn-link text-muted pe-4 text-decoration-none" 
            type="button" 
            (click)="searchTerm = ''">
            <i class="fa-solid fa-xmark"></i>
          </button>
        </div>
      </div>
    </div>

    <!-- Current Session Title & Summary -->
    <div class="row mb-4" *ngIf="currentSession">
      <div class="col-12">
        <div class="d-flex align-items-center justify-content-between flex-wrap gap-2 pb-2 border-bottom">
          <h4 class="fw-bold mb-0 text-dark">
            <i class="fa-solid fa-graduation-cap text-green me-2"></i> {{ currentSession.session }}
          </h4>
          <span class="text-muted small fw-medium">
            Showing {{ filteredCourses.length }} Course Sections
          </span>
        </div>
      </div>
    </div>

    <!-- No Search Results State -->
    <div class="row" *ngIf="filteredCourses.length === 0">
      <div class="col-12 text-center py-5">
        <i class="fa-solid fa-user-slash fa-3x text-muted mb-3 opacity-50"></i>
        <h5 class="fw-bold text-secondary">No Matching Meritorious Students Found</h5>
        <p class="text-muted small">Try searching with a different name, roll number, or clear the search query.</p>
        <button class="btn btn-sm btn-outline-primary rounded-pill px-4" (click)="searchTerm = ''">Clear Search</button>
      </div>
    </div>

    <!-- Course Sections & Tables -->
    <div class="row g-4" *ngIf="filteredCourses.length > 0">
      <div class="col-12" *ngFor="let course of filteredCourses">
        <div class="card border-0 shadow-sm rounded-3 overflow-hidden course-card mb-3">
          
          <!-- Course Card Header -->
          <div class="card-header bg-gradient-green text-white px-4 py-3 d-flex align-items-center justify-content-between flex-wrap gap-2">
            <h5 class="mb-0 fw-bold text-white fs-6">
              <i class="fa-solid fa-book-bookmark me-2 text-light-green"></i> {{ course.courseName }}
            </h5>
            <span class="badge bg-light text-dark fw-bold px-3 py-1.5 rounded-pill" *ngIf="course.hasMerit && course.students.length > 0">
              {{ course.students.length }} Meritorious Student{{ course.students.length > 1 ? 's' : '' }}
            </span>
            <span class="badge bg-secondary text-white px-3 py-1.5 rounded-pill" *ngIf="!course.hasMerit || course.students.length === 0">
              No Merit Record
            </span>
          </div>

          <!-- Course Card Body: Table -->
          <div class="card-body p-0">
            
            <!-- Table when students exist -->
            <div class="table-responsive" *ngIf="course.hasMerit && course.students.length > 0">
              <table class="table table-hover align-middle mb-0 custom-merit-table">
                <thead class="table-light text-uppercase text-secondary" style="font-size: 12px; letter-spacing: 0.05em;">
                  <tr>
                    <th *ngFor="let header of course.headers; let colIdx = index" 
                        scope="col" 
                        class="py-3 px-3"
                        [class.text-center]="colIdx === 0 || colIdx >= 4"
                        [class.text-end]="colIdx === course.headers.length - 1"
                        [style.width]="colIdx === 0 ? '70px' : null">
                      {{ header }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let student of course.students" class="student-row">
                    <td *ngFor="let cell of student.cells; let colIdx = index" 
                        class="py-3 px-3"
                        [class.text-center]="colIdx === 0 || colIdx >= 4"
                        [class.text-end]="colIdx === student.cells.length - 1">
                      
                      <!-- Serial Number (Col 0) -->
                      <span *ngIf="colIdx === 0" class="text-muted fw-bold">{{ cell }}</span>

                      <!-- Roll No. / Reg No. (Col 1) -->
                      <span *ngIf="colIdx === 1" class="fw-semibold text-dark font-monospace" style="font-size: 13px;">{{ cell }}</span>

                      <!-- Student Name (Col 2) -->
                      <span *ngIf="colIdx === 2" class="fw-bold text-green">{{ cell }}</span>

                      <!-- Father's Name (Col 3) -->
                      <span *ngIf="colIdx === 3" class="text-secondary">{{ cell }}</span>

                      <!-- Percentage Badge (last column if percentage) -->
                      <span *ngIf="colIdx >= 4 && colIdx === student.cells.length - 1 && isPercentageCol(course.headers[colIdx])" 
                            class="badge bg-success-subtle text-success border border-success-subtle fw-bold px-2.5 py-1.5 font-monospace fs-6">
                        {{ formatPercentageDisplay(cell) }}
                      </span>

                      <!-- Marks Columns (Col >= 4 and not percentage badge) -->
                      <span *ngIf="colIdx >= 4 && !(colIdx === student.cells.length - 1 && isPercentageCol(course.headers[colIdx]))" 
                            class="fw-semibold text-dark">
                        {{ cell }}
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- Notice when No Merit -->
            <div class="p-4 text-center text-muted" *ngIf="!course.hasMerit || course.students.length === 0">
              <i class="fa-solid fa-circle-info me-1 text-secondary"></i> No Merit students listed for {{ course.courseName }} in this session.
            </div>

          </div>
        </div>
      </div>
    </div>

  </div>
</div>

